<template>
  <div>
    <div v-for="(item, index) in items" :key="index" class="item-container">
      <div
        :id="`itemexpander-${item.jsonid}-${index}`"
        class="item-main"
        :class="{ 'item-active': checkDD(index) }"
        @click="toggleExpand(index)"
      >
        <div class="item-title">
          <i class="icon-travel_insurance_light glyph-lg pr-3" />
          <span>{{ item.title.toUpperCase() }}</span>
        </div>
        <!-- This will be hidden on mobile devices -->
        <div class="item-main-desktop" />
        <!-- This will be hidden on mobile devices -->
        <div class="item-main-desktop" />
        <div class="toggle">
          <span v-if="!expandedTabs.includes(index)">+</span>
          <span v-else>-</span>
        </div>
      </div>
      <div v-if="checkDD(index)" class="item-dropdown">
        <div class="item-dropdown-main">
          <ul>
            <li v-if="item.duration">
              <h4>Duration</h4>
              <p>{{ item.duration }}</p>
            </li>
            <li v-if="item.inclcover">
              <h4>Insurance Includes</h4>
              <p>{{ item.inclcover }}</p>
              <p v-if="alreadyTravelling(item)" class="pt-0">
                Already Travelling Endorsement
              </p>
            </li>
            <li v-if="item.area">
              <h4>Area</h4>
              <p>{{ item.area }}</p>
            </li>
            <li v-if="item.startdate">
              <h4>New start date</h4>
              <p>{{ item.startdate }}</p>
            </li>
            <li v-if="item.bookdate">
              <h4>Amended on</h4>
              <p>{{ item.bookdate }}</p>
            </li>
            <li v-if="item.status">
              <h4>Status</h4>
              <p>{{ item.status }}</p>
            </li>
          </ul>
          <div class="extra-info" />
        </div>
        <div v-if="item.fnotes[0]" class="extra-info-notes">
          Notes
          <ul>
            <li v-for="(note, index) in item.fnotes" :key="index">
              {{ note }}
            </li>
          </ul>
        </div>
        <div class="insurance-details">
          <p class="insurance-number">
            Your Trailfinders Travel Insurance policy number is
            {{ bookingNumber }}
          </p>
          <topup-text />
          <button
            v-for="(link, index) in insLinks"
            :key="index"
            @click="
              () => {
                openLink(link.link);
              }
            "
          >
            <i class="material-icons vtd-mr-3">picture_as_pdf</i>
            <span>{{ link.title }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import topupText from "./insurance-topup-text";

export default {
  mounted(){
    this.populateExpandedTabs()
  },
  components: {
    topupText,
  },
  props: {
    items: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      expandedTabs: [],
    };
  },
  computed: {
    insLinks(_item) {
      if (!_item || !_item.inslinks) return null;
      return _item.inslinks.filter((link) => link.title && link.link);
    },
    bookingNumber() {
      return this.$store.getters["booking/getBookingNumber"];
    },
  },
  methods: {
    checkDD(_index) {
      return this.expandedTabs.includes(_index)
    },
    toggleExpand(_index) {
      if (this.expandedTabs.includes(_index)){
        this.expandedTabs = this.expandedTabs.filter(i => i !== _index)
      } else {
        this.expandedTabs = [...this.expandedTabs, _index]
      }
    },
    openLink(link) {
      window.open(link);
    },
    populateExpandedTabs(){
      const indexes = []
      if (this.items && this.items.length){
        let index = 0
        while (index < this.items.length){
          indexes.push(index)
          index++
        }
      }
      this.expandedTabs = indexes
    },
    alreadyTravelling(_item) {
      if (_item && _item.alreadytravelling === "TRUE") {
        return true;
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles";
</style>
